interface Props {
    texto: string,
    numero?: number
}

export const SpanX: React.FC<Props> = ({ texto, numero = 0 }) => {
    return (
        <span>
            {texto + ' '}
            {numero === 0 ? '' :
                <span
                    style={{
                        color: '#fff',            // Color del texto del número
                        backgroundColor: '#d32f2f', // Fondo rojo
                        padding: '2px 6px',       // Espaciado interno
                        borderRadius: '4px',      // Bordes redondeados
                        fontWeight: 'bold',       // Texto en negrita
                    }}
                >
                    {numero}
                </span>
            }
        </span>
    );
}

export const SpanRed: React.FC<Props> = ({ texto }) => {
    return (
        <span
            style={{
                color: '#fff',            // Color del texto del número
                backgroundColor: '#d32f2f', // Fondo rojo
                padding: '2px 6px',       // Espaciado interno
                borderRadius: '4px',      // Bordes redondeados
                fontWeight: 'bold',       // Texto en negrita
            }}
        >
            {texto}
        </span>
    );
}